import { createContext } from 'react';

export const GlobalStateContext = createContext();
